import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DpBillsReportUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.getDpBillDetailsReport(req);
    }
}
export default DpBillsReportUseCase;
